module.exports = __webpack_public_path__ + "static/img/pro12.d01e63af.png";